var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDECEC",
    d: "M32 5H18v10h18V9a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M11 5H4a4 4 0 0 0-4 4v6h11V5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDECEC",
    d: "M32 31H18V21h18v6a4 4 0 0 1-4 4zm-21 0H4a4 4 0 0 1-4-4v-6h11v10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#003580",
    d: "M18 5h-7v10H0v6h11v10h7V21h18v-6H18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi);
export default __webpack_public_path__ + "static/1769707387/media/fi.997e1474e5c1d2b594b582423a808dc3.svg";
export { ForwardRef as ReactComponent };